import axios from 'axios';
import configRepository from './ConfigRepository';

var LogRepository = function () {
	var _timer = null;
	var _busy = false;


	var _data = {
		/**
		 * Adds a log item to the repo
		 * @param {any} logMessage the log message
		 */
		addLog: function (logMessage, level) {

            try {

				if (!level) {
					level = 0;
				}
				console.log(logMessage);
				var logs = this.getLogs();
				var date = new Date();
				var _this = this;

				logs.push({ Date: date.toLocaleDateString() + ' ' + date.toLocaleTimeString(), Message: logMessage.toString(), Level: level, IsSynced: false });

				// keep the last 100 logs
				while (logs.length > 500) {
					logs.shift();
				}

				window.localStorage.setItem('logitems', JSON.stringify(logs));
				var name = configRepository.getConfig().clientName;
				if (!name)
					name = 'unknown';

				if (_timer) {
					window.clearTimeout(_timer);
				}

				if (!_busy) {
					_timer = window.setTimeout(function () {
						_busy = true;
						_this.sendLogsToServer(name).then(() => {
							_busy = false;
						}, () => {
							_busy = false;
						});
					}, 500);
				}		
            } catch (ex) {
				_busy = false;
			}			
		},

		/** Gets the log items */
		getLogs: function () {
			var logs = JSON.parse(window.localStorage.getItem('logitems') || '[]');
			return logs;
        },

		clearLogs: function () {
			window.localStorage.setItem('logitems', '[]');
		},

		sendLogsToServer: function (name) {

			var logs = this.getLogs();


			// Creating a promise
			var promise = new Promise(function (resolve, reject) {

				
				// filter on the not send logitems
				var logstosend = logs.filter(a => {
					if (!a.IsSynced) {
						a.Syncing = true;
						a.Message = a.Message.toString();
					}
					return !a.IsSynced;
				});

				// directly resolve.
				if (logstosend.length == 0) {
					resolve();
				} else {

                    try {

						// axios, for a full list of options see: https://github.com/axios/axios
						axios({
							method: 'POST',
							data: { from: name, logs: logstosend },
							withCredentials: true,
							url: configRepository.getConfig().endPointUrl + 'api/terminal/' + 'savelogs'
						}).then(function () {
							// all ok, set as send and store
							logstosend.forEach(a => {
								a.IsSynced = true;
							});
							window.localStorage.setItem('logitems', JSON.stringify(logs));
							resolve();
						}).catch(function (err) {
							reject(err);
						});
                    } catch (e) {
						reject(e);
                    }
                }
				
			});

			return promise;

        }

	};

	return _data;
}()

export { LogRepository as default };